<template>
    <div class="d-inline-block">
        <input type="checkbox" class="d-none">
        <button class="btn bg-white" @click="$emit('input', !value)" :class="{'text-muted': !value}">
            <i v-show="value" class="fas fa-check-square" :style="`color: ${activeColor};`"/>
            <i v-show="!value" class="fas fa-square text-muted"/>
            <slot/>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        activeColor: {
            type: String,
            default: 'inherit',
        },
    },
};
</script>
